var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.031 3.781A4.375 4.375 0 0 1 36.22 9.97L12.27 33.917a8.75 8.75 0 0 1-3.688 2.198l-4.475 1.333a1.25 1.25 0 0 1-1.555-1.555l1.333-4.475a8.75 8.75 0 0 1 2.198-3.689L27.21 6.603l.01-.009.009-.01 2.802-2.803zm-1.927 5.466L7.85 29.497a6.25 6.25 0 0 0-1.57 2.635l-.673 2.26 2.26-.673a6.25 6.25 0 0 0 2.384-1.332l.25-.238 20.252-20.252-2.65-2.65zM34.45 5.55a1.875 1.875 0 0 0-2.652 0L29.87 7.477l2.652 2.653 1.93-1.929c.686-.687.729-1.773.128-2.51l-.129-.142z",
    fill: "#8E06BF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilPurple);
export default __webpack_public_path__ + "static/media/pencil-purple.e61b02cfc49b7d9e4dc5013afffa34fa.svg";
export { ForwardRef as ReactComponent };